import { combineReducers } from 'redux';

// Front
import LayoutReducer from './layouts/reducer';
import authReducer from './auth/auth-slice';
import taskListReducer from '../pages/Dashboard/TaskList/slice';
import directorInfoReducer from '../pages/Dashboard/DirectorInfo/slice';
import superAdminReducer from '../pages/Dashboard/SuperAdmin/slice';
import usersReducer from '../pages/Dashboard/Users/slice';
import userDetailsReducer from '../pages/Dashboard/UserDetails/slice';
import packageOrdersReducer from '../pages/Dashboard/PackageOrders/slice';
import packageRankHistoryReducer from '../pages/Dashboard/RankHistory/slice';
import packageRankRewardsReducer from '../pages/Dashboard/RankReward/slice';

import teamsReducer from '../pages/Dashboard/Teams/slice';
import withdrawalsReducer from '../pages/Dashboard/Withdrawals/slice';
import earningsReducer from '../pages/Dashboard/Earnings/slice';
import licensesReducer from '../pages/Dashboard/Licenses/slice';
import travelutionSubscriptionReducer from '../pages/Dashboard/TravelutionSubscription/slice';
import teamBonusReducer from '../pages/Bonuses/TeamBonus/slice';
import tradingTeamBonusReducer from '../pages/Bonuses/TradingTeamBonus/slice';
import directBonusReducer from '../pages/Bonuses/DirectBonus/slice';
import matchingBonusReducer from '../pages/Bonuses/MatchingBonus/slice';
import totalBonusReducer from '../pages/Bonuses/TotalBonus/slice';
import customerBonusReducer from '../pages/Bonuses/CustomerBonus/slice';
import fastStartBonusReducer from '../pages/Bonuses/FastStartBonus/slice';
import globalPoolBonusBonusReducer from '../pages/Bonuses/GlobalPoolBonus/slice';
import topPerformerBonusBonusReducer from '../pages/Bonuses/TopPerformerBonus/slice';
import ContentBlocksReducer from '../pages/Dashboard/ContentBlocks/slice';
import faqReducer from '../pages/Faq/slice';
import balanceChangeReducer from '../pages/Dashboard/BalanceChange/slice';

import membershipsReducer from '../pages/Dashboard/Memberships/slice';
import subscriptionsReducer from '../pages/Dashboard/Subscriptions/slice';
import budleSubscriptionsReducer from '../pages/Dashboard/BundleSubscriptions/slice';
import goldenCardReducer from '../pages/Dashboard/GoldenCard/slice';
import superSalesReducer from '../pages/Dashboard/SuperSales/slice';

export const reducers = combineReducers({
  Layout: LayoutReducer,
  auth: authReducer,
  taskList: taskListReducer,
  directorInfo: directorInfoReducer,
  superAdmin: superAdminReducer,
  users: usersReducer,
  userDetails: userDetailsReducer,
  packageOrders: packageOrdersReducer,

  withdrawals: withdrawalsReducer,

  memberships: membershipsReducer,
  subscriptions: subscriptionsReducer,
  budleSubscriptions: budleSubscriptionsReducer,
  goldenCard: goldenCardReducer,
  superSales: superSalesReducer,

  packageRankHistory: packageRankHistoryReducer,
  packageRankRewards: packageRankRewardsReducer,

  teams: teamsReducer,

  earnings: earningsReducer,
  licenses: licensesReducer,
  travelutionSubscription: travelutionSubscriptionReducer,
  teamBonus: teamBonusReducer,
  tradingTeamBonus: tradingTeamBonusReducer,
  directBonus: directBonusReducer,
  matchingBonus: matchingBonusReducer,
  totalBonus: totalBonusReducer,
  customerBonus: customerBonusReducer,
  fastStartBonus: fastStartBonusReducer,
  globalPoolBonus: globalPoolBonusBonusReducer,
  topPerformerBonus: topPerformerBonusBonusReducer,
  contentBlocks: ContentBlocksReducer,
  faq: faqReducer,
  balanceChange: balanceChangeReducer
});

export type AppState = ReturnType<typeof reducers>;
